import store from "@/store/index";

import BaseService from "./BaseService";

export default {
  create(values) {
    return BaseService.post("referral-doctors", "referral_doctors", values)
      .then(() => Promise.resolve())
      .catch(errors => Promise.reject(errors));
  },

  update(values) {
    return BaseService.patch(
      "referral-doctors",
      `referral_doctors/${values.id}`,
      values
    )
      .then(() => Promise.resolve())
      .catch(errors => Promise.reject(errors));
  },

  delete(id) {
    return BaseService.delete(`referral_doctors/${id}`)
      .then(() => {
        store.dispatch("interview/removeDoctor", id);
      })
      .catch(error => Promise.reject(error.response.data));
  },

  reinstate(id) {
    return BaseService.patch(
      "referral-doctors",
      `referral_doctors/${id}/reinstate`,
      { id }
    )
      .then(() => {
        store.dispatch("interview/reinstateDoctor", id);
        return Promise.resolve();
      })
      .catch(error => Promise.reject(error.response.data));
  }
};
